import { useLocation } from "react-router-dom";
import ExtractSindicatoDetalheV1 from "./ExtractSindicatoDetalheV1";
import ExtractSindicatoDetalheV2 from "./ExtractSindicatoDetalheV2";

const ExtractSindicatoDetalhe = () => {
  const location = useLocation();
  const { selectedYear } = (location.state ?? {}) as { selectedYear?: number };

  if (Number(selectedYear) > 2025) return <ExtractSindicatoDetalheV2 />;
  return <ExtractSindicatoDetalheV1 />;
};

export default ExtractSindicatoDetalhe;
